import './MiniNavbar.scss';

import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { MobileNavbar } from 'organisms/MobileNavbar';

import { NavbarItems } from './NavbarItems';

export function MiniNavbar({ fixToTop = 'true' }) {
  const location = useLocation();
  const { width } = useWindowDimensions();
  const isMobile = width < 592;
  const { isMobileMenuOpen } = useSelector((state) => state.ui);

  const blackVariant = location.pathname === '/';

  return (
    <div
      className={classNames(
        'mini-navbar flex-row justify-between',
        isMobileMenuOpen && 'mini-navbar--open',
        blackVariant && 'mini-navbar--black',
        fixToTop && 'mini-navbar--fix'
      )}
    >
      {isMobile ? (
        <MobileNavbar burgerColor={blackVariant ? 'black' : 'white'}>
          <NavbarItems />
        </MobileNavbar>
      ) : (
        <>
          <Link to="/">
            <Icon
              name="pawcareEmpty"
              style={{ fill: blackVariant ? 'black' : 'white' }}
            />
          </Link>
          <NavbarItems blackVariant={!!blackVariant} />
        </>
      )}
    </div>
  );
}
